import ValueEditorPropertyLabel from "./ValueEditorPropertyLabel";

export default ValueEditorPropertyLabel;
export { ValueEditorPropertyLabel };
